'use client'

import { CloseFilledIcon } from '@repo/ui/CloseFilledIcon'
import { MinimizedOutlineIcon } from '@repo/ui/MinimizedOutlineIcon'
import MUIDivider from '@mui/material/Divider'
import MUIIconButton from '@mui/material/IconButton'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const WizardHeader = ({ title = '', description = '', onClose, onMinimise, wideMode }) => {
  return (
    <MUIStack
      data-testid="WizardHeader"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        width: '100%',
        maxWidth: wideMode ? '1140px' : '1110px',
        height: '72px',
        backgroundColor: 'primary.main',
        borderTopRightRadius: '4px',
        padding: '16px 12px'
      }}
    >
      <MUIStack direction="column" alignItems="flex-start" justifyContent="center">
        <MUITypography variant="h5" sx={{ color: 'white', mb: 0 }}>
          {title}
        </MUITypography>
        <MUITypography variant="body1" sx={{ color: 'text.slate200', mb: 0 }}>
          {description}
        </MUITypography>
      </MUIStack>

      <MUIStack direction="row" alignItems="center" sx={{ height: '40px' }}>
        {onMinimise ? (
          <MUIIconButton
            onClick={onMinimise}
            sx={{
              width: '40px',
              height: '40px',
              padding: '8px',
              '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.04)' }
            }}
            title="Minmise"
          >
            <MinimizedOutlineIcon sx={{ color: 'white' }} />
          </MUIIconButton>
        ) : null}

        {onMinimise ? (
          <MUIDivider
            orientation="vertical"
            sx={{ borderColor: 'secondary.light', borderWidth: '1px', height: '28px' }}
          />
        ) : null}

        <MUIIconButton
          onClick={onClose}
          sx={{
            width: '40px',
            height: '40px',
            padding: '8px',
            '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.04)' }
          }}
          title="Close"
        >
          <CloseFilledIcon sx={{ color: 'white', fontSize: '24px', width: '24px', height: '24px' }} />
        </MUIIconButton>
      </MUIStack>
    </MUIStack>
  )
}

WizardHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func,
  onMinimise: PropTypes.func,
  wideMode: PropTypes.bool
}
